<template>
  <div>
    <div class="row">
      <div class="col-md-8 col-md-offset-2">
        <div class="card card-wizard" id="wizardCard">
          <form-wizard shape="tab"
                       @on-complete="complete"
                       error-color="#EB5E28"
                       color="#66615B"
                       title="Ajout d'une boutique"
                       subtitle="">
            <tab-content title="Nom et adresse"
                         :before-change="validateFirstStep"
                         icon="ti-home">
              <first-step ref="firstStep"></first-step>
            </tab-content>

            <tab-content title="Informations supplémentaires"
                         :before-change="validateSecondStep"
                         icon="ti-settings">
              <second-step ref="secondStep"></second-step>
            </tab-content>

            <tab-content title="Preview"
                         icon="ti-eye">
              <Card v-if="company" :company="company" :store="store" />
            </tab-content>

            <tab-content title="Validation"
                         icon="ti-check">
              <h2 class="text-center text-space">Votre boutique est prête !
                <br>
                <small>Cliquer sur "<b>Terminer</b>" pour finaliser l'ajout de votre boutique.</small>
              </h2>
            </tab-content>

            <button slot="prev" class="btn btn-default btn-fill btn-wd btn-back">Retour</button>
            <button @click="update" slot="next" class="btn btn-info btn-fill btn-wd btn-next">Suivant</button>
            <Uploader v-if="company" slot="finish" ref="uploader" :reference="`/companies/${company.id}/stores`" :value="store" @success="displaySuccess" @error="displayError" />
          </form-wizard>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
  import {FormWizard, TabContent} from 'vue-form-wizard'
  import 'vue-form-wizard/dist/vue-form-wizard.min.css'
  import FirstStep from '@/components/Store/Add/FirstStep.vue'
  import SecondStep from '@/components/Store/Add/SecondStep.vue'
  import Card from '@/components/Store/Card.vue'
  import Uploader from '@/components/Utils/Uploader'
  import swal from 'sweetalert2'
  import { mapActions, mapGetters } from 'vuex'

  export default {
    data () {
      return {
        loading: false,
        store: {}
      }
    },
    components: {
      FormWizard,
      TabContent,
      FirstStep,
      SecondStep,
      Card,
      Uploader
    },
    computed: {
      ...mapGetters('companies', {
        company: 'mine'
      })
    },
    methods: {
      complete () {
        this.$refs.uploader.upload()
      },
      update () {
        this.store = {
          ...this.$refs.firstStep.model,
          ...this.$refs.secondStep.model
        }
      },
      ...mapActions('stores', {
        addStore: 'add'
      }),
      validateFirstStep () {
        return this.$refs.firstStep.validate()
      },
      validateSecondStep () {
        return this.$refs.secondStep.validate()
      },
      displaySuccess (doc) {
        swal('Terminé !', `Votre boutique ${this.store.name} a été ajoutée`, 'success')
        .then((value) => {
          this.$router.push({name: 'Dashboard'})
          // this.$router.push({name: 'StoreView', params: {store: doc.id}})
        })
      },
      displayError (error) {
        swal('Erreur !', `La boutique n'a pas pu être ajoutée : ${error}`, 'error')
      }
    }
  }
</script>
<style>
  .vue-form-wizard .wizard-icon-circle.tab_shape {
    background-color: #9A9A9A !important;
    color: white;
  }
</style>



// WEBPACK FOOTER //
// src/pages/Company/Store/Add.vue